import React from "react";
import "antd/dist/reset.css";
import "bootstrap/dist/css/bootstrap.min.css";
import ImageWebPConverter from "./ImageWebPConverter";

function App() {
  return (
    <div style={{ background: "linear-gradient(120deg, #e4f0fb 0%, #ffffff 100%)", minHeight: "100vh" }}>
      <ImageWebPConverter />
      <footer className="text-center py-3 small border-top">
        Design and Developed by <span className="text-dark">Vishnu🤍.</span>
      </footer>
    </div>
  );
}

export default App;
